export default __webpack_public_path__ + "static/media/gambar_tidak_ditemukan.d804b08f.png";